module.exports = __webpack_public_path__ + "img/87.a60c7abf.png";